import React from "react";
import "./Column.css";

/**
 * Column (uniwersalny)
 * Prosta kolumna, do której możesz wstrzyknąć dowolny header (ReactNode)
 * oraz dowolną zawartość.
 */
export default function Column({ header, children, className = "" }) {
    return (
        <section className={`column ${className}`.trim()}>
            {header ? <div className="column__header">{header}</div> : null}
            <div className="column__body">{children}</div>
        </section>
    );
}